export const GET_LIST_MARKET_COMM_REDUCER = 'GET_LIST_MARKET_COMM_REDUCER';
export const GET_LIST_MARKET_COMM_REQUEST = 'GET_LIST_MARKET_COMM_REQUEST';
export const UPDATE_IS_LOAD_MORE_MARKET_COMM = 'UPDATE_IS_LOAD_MORE_MARKET_COMM';
export const UPDATE_DATA_MARKET_COMM = 'UPDATE_DATA_MARKET_COMM';
export const CHECK_DATA_HIDDEN = 'CHECK_DATA_HIDDEN';
